import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=cd014782"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports